<template>
  <span class="text-[#FF2449] text-[16px] font-bold">*</span>
</template>